import { FC } from "react";
import { ReviewDTO } from "../../../../domain/models/dto/ReviewDTO";
import { useTranslation } from "react-i18next";
import StarsRating from "./StarsRating";
import { getReviewCreatedTime } from "../../../../slices/reviews-slice";
import CurrencyIconSVG from "../../svg/CurrencyIconSVG";
import _ from "lodash";
import { getWorkUserProfileImage } from "../../../../slices/works-slice";
import RatingStarSVG from "../../svg/RatingStarIconSVG";
import { getUserFullName } from "../../../../slices/user-slice";
import CurrencyAmount from "../CurrencyAmount";

interface ReviewCardProps {
    review: ReviewDTO;
}

const ReviewCard: FC<ReviewCardProps> = (props) => {
    const { t } = useTranslation();
    const price = props.review.reviewerPrice || props.review.subjectPrice;

    const fullName = getUserFullName(props.review.reviewer, t);

    return (
        <>
            <div className="flex w-full bg-[rgba(255,255,255,0.1)] hover:bg-[rgba(255,255,255,0.16)] rounded-[10px] py-9 dmax2:py-5 px-10 dmax2:px-4 transition duration-300">
                <div className="flex flex-col w-full">
                    <div className="flex items-start justify-between w-full">
                        <span className="H20B dmax2:H14B text-textWarning truncate text-left mt-1 dmax2:mt-2">
                            {props.review.work?.title}
                        </span>
                        <div className="H16 flex justify-center shrink-0 items-center dmax2:H14 text-textWhite bg-primaryBlue rounded-[30px] w-fit tmax5:h-[30px] px-4 dmax2:px-2.5 py-2 dmax2:py-[7px]">
                            <CurrencyIconSVG className="w-6 dmax2:w-4 h-6 dmax2:h4 mr-3 dmax2:mr-1.5 text-textWhite" />
                            <span>
                                <CurrencyAmount price={price} suffix={t("work.applicationCreation.priceUnits")} />
                            </span>
                        </div>
                    </div>
                    <StarsRating wrapClassName="mt-3" rate={props.review.rate} />
                    <span className="H16 H14 text-textFaded break-words text-left mt-2 dmax2:mt-1">
                        {props.review.comment}
                    </span>
                    <div className="flex justify-between items-end">
                        <div className="relative flex items-center mt-5 mb-5 tmax4:mb-4">
                            <div className="w-[62px] min-w-[62px] tmax4:w-[46px] tmax4:min-w-[46px] h-[62px] min-h-[62px] tmax4:h-[46px] tmax4:min-h-[46px] mr-5 dmax2:mr-2">
                                <img
                                    src={getWorkUserProfileImage(props.review.reviewer, true)}
                                    alt="user"
                                    className="w-full h-full object-cover rounded-full"
                                />
                            </div>
                            <div className="relative flex flex-col">
                                <p className="H16B tmax4:H14B text-textWhite text-left tmax5:line-clamp-2 tmax4:max-w-[110px] ti7:max-w-[210px]">
                                    {fullName}
                                </p>
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center">
                                        <span className="H16B tmax4:H14B text-textWhite mr-1 dmax2:mr-[2px]">
                                            {props.review.reviewer?.avgRating}
                                        </span>
                                        <RatingStarSVG className="w-[21px] dmax2:w-5 mr-2 dmax2:mr-1" />
                                        <span className="H16B tmax4:H14B text-textFaded">
                                            {props.review.reviewer?.reviewsCount}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <span className="H16 dmax2:H14 text-textFaded text-end mt-2">
                            {getReviewCreatedTime(t, props.review, true)}
                        </span>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ReviewCard;
